//import { questHide } from './modules/questHide.js';
//import { topScrol } from './modules/topScrol.js';

document.addEventListener('DOMContentLoaded', () => {
  questHide();
  topScrol()
});
